import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { LeadService } from 'src/app/services/lead.service';

@Injectable()
export class NmjInitialDataEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private service: LeadService,) {
  }

  createLead$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.CreateLeadRequestAction),
    switchMap((action: any) => this.service.createLead(action.data).pipe(
      map((data: any) => {
        window.sessionStorage.setItem('token_name', data.data);
        this.service.showOk(data.message);
        return ActionsList.CreateLeadResponseAction({ data: data.data });
      }),
      catchError(_err => {
        return EMPTY;
      })
    )),
  ));

}
